import { openAlert } from '../../redux/actions/alertActions';
import { getTalkRoom } from '../../redux/actions/talkRoomActions';
import { ResourcesInterface } from "./interfaces";
import {
  connectPartner,
  handleOffer,
  handleAnswer,
  handleCandidate,
  handleToggleMic,
  partnerClosed,
  setParticipant,
} from "./peer";
import { CONFIG } from "../../constants";
import store from '../../redux/store'

const dispatchParticipants = (message: any) => {
  store.dispatch(getTalkRoom({
    walk: 0,
    room: message.meeting_key,
    participant_count: message.participants
  }))
}

export function sendSocket(mess: any, webSocket?: WebSocket) {
  // console.log('sending socket')
  if (webSocket) {
    if (webSocket.readyState !== webSocket.OPEN) {
      // alert("Web socket is not open: " + webSocket.readyState)
      // console.log('send socket', mess, webSocket)
      store.dispatch(openAlert({
        message: 'Någonting gick snett, kunde inte öppna websocket',
        header: 'Felmeddelande'
      }))
      return
    }
    webSocket.send(JSON.stringify(mess))
  }
}

function messageListener(event: any, resources: ResourcesInterface) {
  const message = JSON.parse(event.data)
  // console.log(message, resources)
  if (message.type === 'meeting') {
    if (message.command === 'init') {
      if (message.status === 'first') {
        // console.log('Du är först i mötet...')
      } else if (message.status === 'connect') {
        // console.log(message)
        connectPartner(resources, message.user_id_from, message.user_name_from, message.user_picture_from)
      } else {
        // console.log('Error - unknown status in ', message)
      }
    } else if (message.command === 'offer') {
      // console.log('Got offer')
      handleOffer(resources, message.user_id_from, message.user_name_from, message.user_picture_from,
        message.offer, message.kind)
    } else if (message.command === 'answer') {
      // console.log('Got answer')
      handleAnswer(resources, message.user_id_from, message.answer)
    } else if (message.command === 'icecandidate') {
      // console.log('Got icecandidate')
      handleCandidate(resources, message.user_id_from, message.candidate)
    } else if (message.command === 'chat') {
      resources.stateFunc('chat', message)
    } else if (message.command === 'toggleMic') {
      // console.log('----- toggleMic')
      handleToggleMic(resources, message.user_id_from, message.muted)
    } else if (message.command === 'participant_count') {
      // console.log(' -------', message.participants, message)
      // alert('In meeting right now: ' + message.participants)
      // console.log('******participant', resources.meetingKey, message.meeting_key)
      if(resources.meetingKey && message.meeting_key) {
        setParticipant(message.participants, resources.participantContainer)
      }
      dispatchParticipants(message)

    } else if (message.command === 'close') {
      partnerClosed(resources, message.user_id_from)
    } else if (message.command === 'hangup') {
      // console.log('----- will hangup session')
        if (window.opener) {
          window.opener.console.log('From opened window')
          // console.log('----- Closing window')
          window.opener.postMessage('video_window_close')
        } else {
          window.location.href = '/app/' + resources.who + '/overview'
        }
    }
  } else {
    // console.log('Unknown message type: ' + message.type)
  }
}

export function openSocket(resources: ResourcesInterface) {

  if (resources.webSocket) {
    alert('Fatal error - trying to open socket that we already opened')
    return
  }
  resources.webSocket = new WebSocket(CONFIG.WEB_SOCKET_ENDPOINT)

  if (resources.webSocket) {
    // console.log('reating new newsocket')
    resources.webSocket.addEventListener('message', function(event) {
      messageListener(event, resources)
    })
    resources.webSocket.addEventListener('error', function (event:any) {
      if (event.target?.readyState === WebSocket.CLOSED) {
        resources.stateFunc('info', 'WebSocket is closed. If things do not work, talk to support')
        resources.stateFunc('showInfo', true)
      }
    })
  }

  resources.webSocketPingInterval = setInterval(() => {
    if (resources.webSocket) {
      if (resources.webSocket.readyState === resources.webSocket.OPEN) {
        const mess = {
          type: 'ping'
        }
        resources.webSocket.send(JSON.stringify(mess))
      } else {
        // console.log('Fatal error: webSocket not open: ' + resources.webSocket.readyState)
      }
    } else {
      // console.log('No webSocket!')
    }
  }, 30000)

}

// When we have a local video stream (and websocket), we can connect
export function connectMeeting(resources: ResourcesInterface) {
  const mess = {
    type: 'meeting',
    command: 'init',
    key: resources.meetingKey
  }
  // console.log('---- Sending meeting init')
  sendSocket(mess, resources.webSocket)
}

export function closeSocket(resources: ResourcesInterface) {
  if (resources.webSocket) {
    resources.webSocket.removeEventListener('message', function(event) {
      messageListener(event, resources)
    })
    resources.webSocket.close()
    clearInterval(resources.webSocketPingInterval)
    resources.webSocket = undefined
  }

}
